import { render } from "./ServicesComponent.vue?vue&type=template&id=19227f58&scoped=true"
import script from "./ServicesComponent.vue?vue&type=script&lang=js"
export * from "./ServicesComponent.vue?vue&type=script&lang=js"

import "./ServicesComponent.vue?vue&type=style&index=0&id=19227f58&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ahmed.shaker.KORABIA\\Desktop\\hesabtech-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19227f58"]])

export default __exports__